module.exports = __webpack_public_path__ + "static/img/2911_phase_function_Paper_PointsHejduk_Prediction.cc3145c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2911_phase_function_Paper_PointsHejduk_Prediction.png
// module id = y+CQ
// module chunks = 0